import Node from '../node.js';
import { PARAM_TYPE } from '../connector.js';
import Spline from '../spline.js';
import Utils3D from '../../utils/utils3D.js';

import Utils from '../utils.js';

export default class NodeCopyAlongPath extends Node
{
	static COPY_TYPES =
	[
		{key: 'vertsOnly', label: 'Copy to Vertices Only'},
		{key: 'resample', label: 'Copy Along Resampled Path'},
	]

	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'object', null);
		this.addInput(PARAM_TYPE.SPLINE, 'path', null);

		this.addInput(PARAM_TYPE.DROPDOWN, 'copy_type', NodeCopyAlongPath.COPY_TYPES[1].key, { dropdownOptions: NodeCopyAlongPath.COPY_TYPES });

		this.addInput(PARAM_TYPE.BOOLEAN, 'orient_with_path', true);

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}

	getType()
	{
		return 'copyAlongPath';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		let pCopyObjects = inputValues['object'];
		if(!pCopyObjects || pCopyObjects.length === 0)
			return null;

		if(!Array.isArray(pCopyObjects))
			pCopyObjects = [pCopyObjects];

		pCopyObjects = pCopyObjects.filter((obj) => { return Utils.getIsMeshObject(obj); });
		if(pCopyObjects.length === 0)
			return null;

		let listPath = inputValues['path'];
		if(!listPath || listPath.points.length < 1)
			return null;

		let pPathSpline = new Spline(listPath);

		let pLinearPoints = pPathSpline.getLinearPoints(true, true, pPathSpline.getIs3D() ? null : 'xz');

		let objectsBBox = Utils3D.getObjectsBBoxWithChildren(pCopyObjects);

		let vecCurrCenter = objectsBBox.maximumWorld.add(objectsBBox.minimumWorld).scale(0.5);

		let iCounter = 0;
		let pFinalMesh;
		let pFinalMeshes = [];
		for(let pPoint of pLinearPoints)
		{
			let vecShift = pPoint.subtract(vecCurrCenter);
			for(let pSrcMesh of pCopyObjects)
			{
				pFinalMesh = Utils3D.cloneMesh(pSrcMesh, this.getGeneratedMeshName() + "_" + iCounter);
				this.onMeshCreated(pFinalMesh);
				iCounter++;

				pFinalMesh.position = pFinalMesh.position.add(vecShift);

				pFinalMeshes.push(pFinalMesh);
			}
		}

		for(let pMesh of pCopyObjects)
			pMesh.dispose();

		return pFinalMeshes;
	}

}